import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { AccordionElement } from '@website-builder/widgets/accordion/accordion-element';
import { AccordionTextStyle } from '@website-builder/widgets/accordion/model/accordion-text-style';
import { AccordionButtonStyle } from '@website-builder/widgets/accordion/model/accordion-button-style';
import { AccordionImageStyle } from '@website-builder/widgets/accordion/model/accordion-image-style';
import { AccordionTitleStyle } from '@website-builder/widgets/accordion/model/accordion-title-style';
import { AccordionElementStyle } from '@website-builder/widgets/accordion/model/accordion-element-style';
import { AccordionGridStyle } from '@website-builder/widgets/accordion/model/accordion-grid-style';
import { AccordionStyle } from '@website-builder/widgets/accordion/model/accordion-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class AccordionWidget extends BaseMultipleWidget<AccordionElement, AccordionStyle> {
  readonly type = BuilderElementType.Accordion;
  style = new AccordionStyle();
  multipleItemsOpen = false;
  canBeAllClosed = true;
  gridStyle = new AccordionGridStyle();
  elementStyle = new AccordionElementStyle();
  titleStyle = new AccordionTitleStyle();
  imageStyle = new AccordionImageStyle();
  buttonStyle = new AccordionButtonStyle();
  textStyle = new AccordionTextStyle();
  elements: AccordionElement[] = [new AccordionElement()];

  static normalizeInPlace(widget: AccordionWidget): AccordionWidget {
    const pureWidget = new AccordionWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.multipleItemsOpen = widget.multipleItemsOpen ?? pureWidget.multipleItemsOpen;
    widget.canBeAllClosed = widget.canBeAllClosed ?? pureWidget.canBeAllClosed;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => AccordionElement.normalizeInPlace(element));

    widget.style = AccordionStyle.normalize(widget.style);
    widget.gridStyle = AccordionGridStyle.normalize(widget.gridStyle);
    widget.elementStyle = AccordionElementStyle.normalize(widget.elementStyle);
    widget.titleStyle = AccordionTitleStyle.normalize(widget.titleStyle);
    widget.imageStyle = AccordionImageStyle.normalize(widget.imageStyle);
    widget.buttonStyle = AccordionButtonStyle.normalize(widget.buttonStyle);
    widget.textStyle = AccordionTextStyle.normalize(widget.textStyle);

    return widget;
  }
}
